module.exports = __webpack_public_path__ + "img/oly-logo.3f26f436.png";